import { createSlice } from '@reduxjs/toolkit';
import AppError from '../../models/error';
import axios from '../../config/axios-config';
import { setApiSuccess, setApiError, setApiLoading, ApiStatusKeys } from './apiStatusSlice';
import { v4 as uuidv4 } from 'uuid';
import { handleApiError } from '../../helpers/errorHelper';

const initialState = {
  keyword: localStorage.getItem('search-keyword') || null,
  searchId: localStorage.getItem('search-id') || null,
  selectedCategoryId: localStorage.getItem('selected-category-id') || null,
  selectedCity: localStorage.getItem('selected-city') || null,
  filtersOn: false,
  searchResult:
    {
      categories: [],
      coaches: [],
      cities: [],
    } || null,
  error: null,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchKeyword: (state, action) => {
      if (state.keyword != action.payload) {
        state.keyword = action.payload;

        if (state.keyword != '') {
          state.searchId = uuidv4();
          localStorage.setItem('search-id', state.searchId);
          localStorage.setItem('search-keyword', action.payload);
        } else {
          localStorage.removeItem('search-id');
          localStorage.removeItem('search-keyword');
        }
      }
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategoryId = action.payload;
      state.filtersOn = true;
      localStorage.setItem('selected-category-id', action.payload);
    },
    setSelectedCity: (state, action) => {
      state.selectedCity = action.payload;
      state.filtersOn = true;
      localStorage.setItem('selected-city', action.payload);
    },
    clearFilters: (state) => {
      state.selectedCategoryId = null;
      state.selectedCity = null;
      localStorage.removeItem('selected-category-id');
      localStorage.removeItem('selected-city');
      state.searchResult.categories = [];
      state.searchResult.cities = [];
      state.searchResult.coaches = [];
      state.filtersOn = false;
    },
    setSearchResult: (state, action) => {
      state.searchResult = {
        coaches: action.payload.coaches || [],
        cities: action.payload.cities || [],
        categories: action.payload.categories || [],
      };
    },
    setError: (state, action) => {
      state.error = action.payload instanceof AppError ? action.payload : AppError.fromJson(action.payload);
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setSearchKeyword,
  setSelectedCategory,
  setSelectedCity,
  setError,
  clearError,
  setSearchResult,
  clearFilters,
} = searchSlice.actions;

export const search = async (dispatch, getState) => {
  try {
    dispatch(setApiLoading(ApiStatusKeys.SEARCH));

    const lang = getState().language.lang;
    const id = getState().search.searchId;
    const city = getState().search.selectedCity;
    const categoryId = getState().search.selectedCategoryId;
    const keyword = getState().search.keyword;
    const country = 'TR';

    const searchRequest = {
      id: id,
      keyword: keyword,
      language: lang,
      city: city,
      country: country,
      categoryId: categoryId,
    };

    const response = await axios.post('/search/search', searchRequest);

    if (response.data.success) {
      dispatch(setSearchResult(response.data));
      dispatch(setApiSuccess({ key: ApiStatusKeys.SEARCH }));
    } else {
      throw new Error(response.data.errorMessage);
    }
  } catch (error) {
    handleApiError(error, ApiStatusKeys.SEARCH, dispatch, 'errors.search_failed');
    throw error;
  }
};

export default searchSlice.reducer;
